

// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes } from "react-icons/fa";  // Location icon, Menu icon, Close icon
// import { FaLanguage } from "react-icons/fa";   
// import logo from '../assets/logo.png';

// const Navbar = () => {
//   const [location, setLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false); // State to control mobile menu

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   return (
//     <div className="w-full h-auto mx-auto">

//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-28 bg-[#FF9630]">
//         {/* Left Section: Welcome Message */}
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         {/* Right Section: Location and Language Dropdowns */}
//         <div className="hidden md:flex items-center space-x-4">
//           {/* Location Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={location}
//               onChange={(e) => setLocation(e.target.value)}
//               className="border border-gray-400 rounded-md text-white pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {locations.map((loc, index) => (
//                 <option key={index} value={loc}>
//                   {loc}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Language Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between px-4 md:px-28">
//         {/* Left Side: Logo */}


//         {/* Right Side: Navigation Items and Hamburger Menu */}
//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? <FaTimes className="text-gray-700 w-6 h-6" /> : <FaBars className="text-gray-700 w-6 h-6" />}
//           </button>
//         </div>
//          <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         <div className="hidden md:flex space-x-6 text-sm font-medium text-gray-700">
//           <a href="#" className="hover:text-indigo-500">Home</a>
//           <a href="#" className="hover:text-indigo-500">Our Fleet</a>
//           <a href="#" className="hover:text-indigo-500">Offers</a>
//           <a href="#" className="hover:text-indigo-500">Partner with us</a>
//           <a href="#" className="hover:text-indigo-500">Sign In</a>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="#" className="hover:text-indigo-500">Home</a>
//             <a href="#" className="hover:text-indigo-500">Our Fleet</a>
//             <a href="#" className="hover:text-indigo-500">Offers</a>
//             <a href="#" className="hover:text-indigo-500">Partner with us</a>
//             <a href="#" className="hover:text-indigo-500">Sign In</a>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;




// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes } from "react-icons/fa";  // Location icon, Menu icon, Close icon
// import { FaLanguage } from "react-icons/fa";   
// import logo from '../assets/logo.png';

// const Navbar = () => {
//   const [location, setLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false); // State to control mobile menu

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   return (
//     <div className="w-full h-auto mx-auto">

//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-28 bg-[#FF9630]">
//         {/* Left Section: Welcome Message */}
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         {/* Right Section: Location and Language Dropdowns */}
//         <div className="hidden md:flex items-center space-x-4">
//           {/* Location Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={location}
//               onChange={(e) => setLocation(e.target.value)}
//               className="border border-gray-400 rounded-md text-white pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {locations.map((loc, index) => (
//                 <option key={index} value={loc}>
//                   {loc}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Language Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between px-4 md:px-28">
//         {/* Left Side: Logo */}


//         {/* Right Side: Navigation Items and Hamburger Menu */}
//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? <FaTimes className="text-gray-700 w-6 h-6" /> : <FaBars className="text-gray-700 w-6 h-6" />}
//           </button>
//         </div>
//          <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         <div className="hidden md:flex space-x-6 text-sm font-medium text-gray-700">
//           <a href="/" className="hover:text-indigo-500">Home</a>
//           <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//           <a href="/offers" className="hover:text-indigo-500">Offers</a>
//           <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>
//           <a href="#" className="hover:text-indigo-500">Sign In</a>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="#" className="hover:text-indigo-500">Home</a>
//             <a href="#" className="hover:text-indigo-500">Our Fleet</a>
//             <a href="#" className="hover:text-indigo-500">Offers</a>
//             <a href="#" className="hover:text-indigo-500">Partner with us</a>
//             <a href="#" className="hover:text-indigo-500">Sign In</a>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage } from "react-icons/fa";
// import logo from "../assets/logo.png";

// const Navbar = () => {
//   const [location, setLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false); // State to control mobile menu
//   const [isSignInOpen, setIsSignInOpen] = useState(false); // State to toggle Sign In dropdown

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];
//   const signInOptions = ["Profile", "Bookings", "Wallet", "Settings", "Logout"];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const toggleSignIn = () => {
//     setIsSignInOpen(!isSignInOpen);
//   };

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-28 bg-[#FF9630]">
//         {/* Left Section: Welcome Message */}
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         {/* Right Section: Location and Language Dropdowns */}
//         <div className="hidden md:flex items-center space-x-4">
//           {/* Location Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={location}
//               onChange={(e) => setLocation(e.target.value)}
//               className="border border-gray-400 rounded-md text-white pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {locations.map((loc, index) => (
//                 <option key={index} value={loc}>
//                   {loc}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Language Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between px-4 md:px-32">
//         {/* Left Side: Logo */}
//         <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         {/* Right Side: Navigation Items and Hamburger Menu */}
//         <div className="hidden md:flex space-x-6 text-sm font-medium text-gray-700">
//           <a href="/" className="hover:text-indigo-500">
//             Home
//           </a>
//           <a href="/product" className="hover:text-indigo-500">
//             Our Fleet
//           </a>
//           <a href="/offers" className="hover:text-indigo-500">
//             Offers
//           </a>
//           <a href="/franchise" className="hover:text-indigo-500">
//             Partner with us
//           </a>
//           {/* Sign In with Dropdown */}
//           <div className="relative">
//             <button
//               onClick={toggleSignIn}
//               className="hover:text-indigo-500 focus:outline-none"
//             >
//               Sign In
//             </button>
//             {isSignInOpen && (
//               <div className="absolute top-full right-0 mt-2 w-40 bg-white shadow-md rounded-md py-2 z-10">
//                 {signInOptions.map((option, index) => (
//                   <a
//                     key={index}
//                     href={`/${option.toLowerCase()}`}
//                     className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                   >
//                     {option}
//                   </a>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Hamburger Menu for Mobile */}
//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             <a href="/signin" className="hover:text-indigo-500">
//               Sign In
//             </a>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage } from "react-icons/fa";
// import logo from "../assets/logo2.png";

// const Navbar = () => {
//   const [location, setLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false); // State to control mobile menu
//   const [isSignInOpen, setIsSignInOpen] = useState(false); // State to toggle Sign In dropdown

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];
//   const signInOptions = ["Profile", "Bookings", "Wallet", "Settings", "Logout"];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const toggleSignIn = () => {
//     setIsSignInOpen(!isSignInOpen);
//   };

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         {/* Left Section: Welcome Message */}
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         {/* Right Section: Location and Language Dropdowns */}
//         <div className="hidden md:flex items-center space-x-4">
//           {/* Location Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={location}
//               onChange={(e) => setLocation(e.target.value)}
//               className="border border-gray-400 rounded-md text-white pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {locations.map((loc, index) => (
//                 <option key={index} value={loc}>
//                   {loc}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Language Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between px-4 md:px-28">
//         {/* Left Side: Logo */}
//         <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         {/* Right Side: Navigation Items and Hamburger Menu */}
//         <div className="hidden md:flex space-x-6 text-md font-medium text-gray-700 relative">
//           <a href="/" className="hover:text-indigo-500">
//             Home
//           </a>
//           <a href="/product" className="hover:text-indigo-500">
//             Our Fleet
//           </a>
//           <a href="/offers" className="hover:text-indigo-500">
//             Offers
//           </a>
//           <a href="/franchise" className="hover:text-indigo-500">
//             Partner with us
//           </a>
//           {/* Sign In with Dropdown */}
//           <div className="relative">
//             <button
//               onClick={toggleSignIn}
//               className="hover:text-indigo-500 focus:outline-none"
//             >
//               Sign In
//             </button>
//             {isSignInOpen && (
//               <div className="absolute top-full right-0 mt-2 w-32 bg-white shadow-md rounded-md py-2 z-10 border border-gray-200">
//                 {signInOptions.map((option, index) => (
//                   <a
//                     key={index}
//                     href={`/${option.toLowerCase()}`}
//                     className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                   >
//                     {option}
//                   </a>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Hamburger Menu for Mobile */}
//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             <a href="/signin" className="hover:text-indigo-500">
//               Sign In
//             </a>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage } from "react-icons/fa";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import logo from "../assets/logo2.png";

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location"); // Renamed variable
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false); // State to control mobile menu
//   const [isSignInOpen, setIsSignInOpen] = useState(false); // State to toggle Sign In dropdown

//   const navigate = useNavigate(); // Initialize the useNavigate hook

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];
//   const signInOptions = ["Profile", "Bookings", "Wallet", "Settings", "Logout"];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const toggleSignIn = () => {
//     setIsSignInOpen(!isSignInOpen);
//   };

//   const handleLocationClick = (location) => {
//     // Navigate to the page based on the location clicked (e.g., "/location/new-york")
//     navigate('/location');
//   };

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         {/* Left Section: Welcome Message */}
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         {/* Right Section: Location and Language Dropdowns */}
//         <div className="hidden md:flex items-center space-x-4  ">
//           {/* Location (Clickable) */}
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm" onClick={() => handleLocationClick(selectedLocation)}>
//               {selectedLocation} {/* Updated variable */}
//             </div>
//           </div>

//           {/* Language Dropdown */}
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         {/* Left Side: Logo */}
//         <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         {/* Right Side: Navigation Items and Hamburger Menu */}
//         <div className="hidden md:flex space-x-6 text-md font-medium  text-gray-700 relative">
//           <a href="/" className="hover:text-indigo-500">
//             Home
//           </a>
//           <a href="/product" className="hover:text-indigo-500">
//             Our Fleet
//           </a>
//           <a href="/offers" className="hover:text-indigo-500">
//             Offers
//           </a>
//           <a href="/franchise" className="hover:text-indigo-500">
//             Partner with us
//           </a>
//           {/* Sign In with Dropdown */}
//           <div className="relative">
//             <button
//               onClick={toggleSignIn}
//               className="hover:text-indigo-500 focus:outline-none"
//             >
//               Sign In
//             </button>
//             {isSignInOpen && (
//               <div className="absolute top-full right-0 mt-2 w-32 bg-white shadow-md rounded-md py-2 z-10 border border-gray-200">
//                 {signInOptions.map((option, index) => (
//                   <a
//                     key={index}
//                     href={`/${option.toLowerCase()}`}
//                     className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                   >
//                     {option}
//                   </a>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Hamburger Menu for Mobile */}
//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             <a href="/signin" className="hover:text-indigo-500">
//               Sign In
//             </a>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage, FaUser } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux"; // Import Redux hooks
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import logo from "../assets/logo2.png";
// import { setUsername } from "../../Auth/Slice/LoginSlice";


// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state
//   const [userName, setUserName] = useState(""); // Store username

//   const navigate = useNavigate();

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];
//   const signInOptions = ["Profile", "Bookings", "Wallet", "Settings", "Logout"];

//   const username = useSelector((state) => state.user.username);
// <div> {username}</div>;

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const toggleSignIn = () => {
//     setIsSignInOpen(!isSignInOpen);
//   };

//   const handleLocationClick = (location) => {
//     navigate('/location');
//   };

//   const handleSignIn = () => {
//     // Simulate login
//     setIsLoggedIn(true);
//     setUserName(""); // You can get the username from your backend or authentication service
//     navigate("sign-in"); // Redirect to the dashboard or another page after login
//   };

//   const handleSignOut = () => {
//     setIsLoggedIn(false);
//     setUserName("");
//     navigate("/"); // Redirect to home page after logout
//   };

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={() => handleLocationClick(selectedLocation)}
//             >
//               {selectedLocation}
//             </div>
//           </div>

//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         <div className="hidden md:flex space-x-6 text-md font-medium text-gray-700 relative">
//           <a href="/" className="hover:text-indigo-500">Home</a>
//           <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//           <a href="/offers" className="hover:text-indigo-500">Offers</a>
//           <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>

//           {isLoggedIn ? (
//             // Show username and sidebar if logged in
//             <div className="relative">
//               <button
//                 onClick={toggleSignIn}
//                 className="hover:text-indigo-500 focus:outline-none"
//               >
//                 <FaUser className="inline mr-2" /> {userName}
//               </button>
//               {isSignInOpen && (
//                 <div className="absolute top-full right-0 mt-2 w-32 bg-white shadow-md rounded-md py-2 z-10 border border-gray-200">
//                   {signInOptions.map((option, index) => (
//                     <a
//                       key={index}
//                       href={`/${option.toLowerCase()}`}
//                       className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       {option}
//                     </a>
//                   ))}
//                   <a
//                     href="/"
//                     className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     onClick={handleSignOut} // Log out option
//                   >
//                     Logout
//                   </a>
//                 </div>
//               )}
//             </div>
//           ) : (
//             // Show "Sign In" button if not logged in
//             <button
//               onClick={handleSignIn}
//               className="hover:text-indigo-500 focus:outline-none"
//             >
//               Sign In
//             </button>
//           )}
//         </div>

//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//         </div>
//       </div>

//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="/" className="hover:text-indigo-500">Home</a>
//             <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//             <a href="/offers" className="hover:text-indigo-500">Offers</a>
//             <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>
//             {isLoggedIn ? (
//               <a href="/" className="hover:text-indigo-500" onClick={handleSignOut}>Logout</a>
//             ) : (
//               <a href="/signin" className="hover:text-indigo-500">Sign In</a>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage, FaUser } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux"; // Import Redux hooks
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import logo from "../assets/logo2.png";
// import { setUsername } from "../../Auth/Slice/LoginSlice"; 
// import {logout} from "../../Auth/Slice/LoginSlice";

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const username = useSelector((state) => state.user.username); // Access username from Redux store

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];
//   const signInOptions = ["Profile", "Bookings", "Wallet", "Settings", "Logout"];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const toggleSignIn = () => {
//     setIsSignInOpen(!isSignInOpen);
//   };

//   const handleLocationClick = (location) => {
//     navigate('/location');
//   };

//   const handleSignIn = () => {
//     // Simulate login
//     setIsLoggedIn(true);
//     dispatch(setUsername("")); // Dispatch action to update username in Redux store
//     navigate("sign-in"); // Redirect to the dashboard or another page after login
//   };

//   const handleSignOut = () => {
//     setIsLoggedIn(false);
//     dispatch(setUsername("")); // Clear username from Redux store
//     navigate("/"); // Redirect to home page after logout
//   };

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={() => handleLocationClick(selectedLocation)}
//             >
//               {selectedLocation}
//             </div>
//           </div>

//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         <div className="hidden md:flex space-x-6 text-md font-medium text-gray-700 relative">
//           <a href="/" className="hover:text-indigo-500">Home</a>
//           <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//           <a href="/offers" className="hover:text-indigo-500">Offers</a>
//           <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>

//           {isLoggedIn ? (
//             // Show username and sidebar if logged in
//             <div className="relative">
//               <button
//                 onClick={toggleSignIn}
//                 className="hover:text-indigo-500 focus:outline-none"
//               >
//                 <FaUser className="inline mr-2" /> {username} {/* Display username from Redux */}
//               </button>
//               {isSignInOpen && (
//                 <div className="absolute top-full right-0 mt-2 w-32 bg-white shadow-md rounded-md py-2 z-10 border border-gray-200">
//                   {signInOptions.map((option, index) => (
//                     <a
//                       key={index}
//                       href={`/${option.toLowerCase()}`}
//                       className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       {option}
//                     </a>
//                   ))}
//                   <a
//                     href="/"
//                     className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     onClick={handleSignOut} // Log out option
//                   >
//                     Logout
//                   </a>
//                 </div>
//               )}
//             </div>
//           ) : (
//             // Show "Sign In" button if not logged in
//             <button
//               onClick={handleSignIn}
//               className="hover:text-indigo-500 focus:outline-none"
//             >
//               Sign In
//             </button>
//           )}
//         </div>

//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//         </div>
//       </div>

//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="/" className="hover:text-indigo-500">Home</a>
//             <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//             <a href="/offers" className="hover:text-indigo-500">Offers</a>
//             <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>
//             {isLoggedIn ? (
//               <a href="/logout" className="hover:text-indigo-500" onClick={handleSignOut}>Logout</a>
//             ) : (
//               <a href="/signin" className="hover:text-indigo-500">Sign In</a>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;



// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaSignOutAlt, FaLanguage, FaUser, FaIdCard } from "react-icons/fa";
// import { FaUserCircle, FaClipboardList, FaWallet } from "react-icons/fa"
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { setUsername, logout } from "../../Auth/Slice/LoginSlice"; // Import actions

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // Get username from Redux store
//   const username = useSelector((state) => state.user.username);

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];
//   const signInOptions = [
//     { label: "Profile", icon: <FaUserCircle />, path: "/profile" },
//     { label: "MyRide", icon: <FaClipboardList />, path: "/profile/myride" },
//     { label: "Wallet", icon: <FaWallet />, path: "/profile/wallet-amt" },
//     { label: "MemberShip", icon: < FaIdCard />, path: "/membership-card" },
//   ];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const toggleSignIn = () => {
//     setIsSignInOpen(!isSignInOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignIn = () => {
//     // Simulate login and set username
//     dispatch(setUsername("Guest")); // Replace with actual username logic
//     navigate("sign-in"); // Redirect to dashboard or desired page
//   };

//   const handleSignOut = () => {
//     dispatch(logout()); // Clear username from Redux store
//     navigate("/logout");
//   };

//   return (
//     <div className="w-full h-auto mx-auto ">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>

//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         <div className="flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         <div className="hidden md:flex space-x-6 text-md font-medium text-gray-700 relative">
//           <a href="/" className="hover:text-indigo-500">Home</a>
//           <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//           <a href="/offers" className="hover:text-indigo-500">Offers</a>
//           <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>

//           {username !== "Guest" ? (
//             <div className="relative">
//               <button
//                 onClick={toggleSignIn}
//                 className="hover:text-indigo-500 focus:outline-none"
//               >
//                 <FaUserCircle className="inline mr-2" /> {username}
//               </button>

//               {isSignInOpen && (
//                 <div className="absolute top-full mt-2 w-36 h-auto bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                   {signInOptions.map((option, index) => (
//                     <a
//                       key={index}
//                       href={option.path}  // Use the path directly from the signInOptions
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <span className="mr-2">{option.icon}</span> {option.label}
//                     </a>
//                   ))}
//                   <a
//                     href="/"
//                     className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     onClick={handleSignOut}
//                   >
//                     <FaSignOutAlt className="mr-2" /> Logout
//                   </a>
//                 </div>
//               )}

//             </div>
//           ) : (
//             <button
//               onClick={handleSignIn}
//               className="hover:text-indigo-500 focus:outline-none"
//             >
//               Guest
//             </button>
//           )}
//         </div>

//         <div className="md:hidden flex items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//         </div>
//       </div>

//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="/" className="hover:text-indigo-500">Home</a>
//             <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//             <a href="/offers" className="hover:text-indigo-500">Offers</a>
//             <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>
//             {username !== "Guest" ? (
//               <a
//                 href="/"
//                 className="hover:text-indigo-500"
//                 onClick={handleSignOut}
//               >
//                 Logout
//               </a>
//             ) : (
//               <a
//                 href="/signin"
//                 className="hover:text-indigo-500"
//                 onClick={handleSignIn}
//               >
//                 Sign In
//               </a>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;

// import React, { useState } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaSignOutAlt, FaLanguage, FaUser, FaIdCard } from "react-icons/fa";
// import { FaUserCircle, FaClipboardList, FaWallet } from "react-icons/fa"
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { setUsername, logout } from "../../Auth/Slice/LoginSlice"; // Import actions

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const username = useSelector((state) => state.user.username);

//   const locations = ["New York", "San Francisco", "Los Angeles", "Chicago"];
//   const languages = ["English", "Spanish", "French", "German"];
//   const signInOptions = [
//     { label: "Profile", icon: <FaUserCircle />, path: "/profile" },
//     { label: "MyRide", icon: <FaClipboardList />, path: "/profile/myride" },
//     { label: "Wallet", icon: <FaWallet />, path: "/profile/wallet-amt" },
//     { label: "MemberShip", icon: <FaIdCard />, path: "/membership-card" },
//   ];

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const toggleSignIn = () => {
//     setIsSignInOpen(!isSignInOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignIn = () => {
//     dispatch(setUsername("Guest")); 
//     navigate("sign-in");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {languages.map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28 relative">
//         {/* Mobile Location */}
//         <div className="flex items-center space-x-4 md:hidden">
//           <div
//             className="relative border border-gray-400 rounded-lg flex items-center"
//             onClick={handleLocationClick}
//           >
//             <FaMapMarkerAlt className="text-[#FF9630] w-4 h-4 ml-2" />
//             <span className="text-sm pl-2 pr-3">{selectedLocation}</span>
//           </div>
//           <img src={logo} alt="Logo" className="h-10" />
//         </div>

//         {/* Desktop Logo */}
//         <div className="hidden md:flex items-center">
//           <img src={logo} alt="Logo" className="h-14" />
//         </div>

//         <div className="hidden md:flex space-x-6 text-md font-medium text-gray-700">
//           <a href="/" className="hover:text-indigo-500">Home</a>
//           <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//           <a href="/offers" className="hover:text-indigo-500">Offers</a>
//           <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>

//           {username !== "Guest" ? (
//             <div className="relative">
//               <button
//                 onClick={toggleSignIn}
//                 className="hover:text-indigo-500 focus:outline-none"
//               >
//                 <FaUserCircle className="inline mr-2" /> {username}
//               </button>

//               {isSignInOpen && (
//                 <div className="absolute top-full mt-2 w-36 bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                   {signInOptions.map((option, index) => (
//                     <a
//                       key={index}
//                       href={option.path}
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <span className="mr-2">{option.icon}</span> {option.label}
//                     </a>
//                   ))}
//                   <a
//                     href="/"
//                     className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     onClick={handleSignOut}
//                   >
//                     <FaSignOutAlt className="mr-2" /> Logout
//                   </a>
//                 </div>
//               )}
//             </div>
//           ) : (
//             <button
//               onClick={handleSignIn}
//               className="hover:text-indigo-500 focus:outline-none"
//             >
//               Guest
//             </button>
//           )}
//         </div>

//         {/* Hamburger Menu */}
//         <div className="flex md:hidden items-center">
//           <button onClick={toggleMenu}>
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//         </div>
//       </div>

//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute top-20 left-0 w-full z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-gray-700">
//             <a href="/" className="hover:text-indigo-500">Home</a>
//             <a href="/product" className="hover:text-indigo-500">Our Fleet</a>
//             <a href="/offers" className="hover:text-indigo-500">Offers</a>
//             <a href="/franchise" className="hover:text-indigo-500">Partner with us</a>
//             {username !== "Guest" ? (
//               <a
//                 href="/"
//                 className="hover:text-indigo-500"
//                 onClick={handleSignOut}
//               >
//                 Logout
//               </a>
//             ) : (
//               <a
//                 href="/signin"
//                 className="hover:text-indigo-500"
//                 onClick={handleSignIn}
//               >
//                 Sign In
//               </a>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;

// import React, { useState } from "react";
// import {
//   FaMapMarkerAlt,
//   FaBars,
//   FaTimes,
//   FaSignOutAlt,
//   FaLanguage,
//   FaUserCircle,
//   FaClipboardList,
//   FaWallet,
//   FaIdCard,
// } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { setUsername, logout } from "../../Auth/Slice/LoginSlice"; // Import actions

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   // Get username from Redux store
//   const username = useSelector((state) => state.user.username);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {["English", "Spanish", "French", "German"].map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         {/* Mobile View */}
//         <div className="flex items-center md:hidden w-full">
//           <button onClick={toggleMenu} className="mr-4">
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//           <img src={logo} alt="Logo" className="h-11 mr-6" />
//           <div className="relative flex-grow">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
//             </div>
//             <div
//               className="cursor-pointer text-gray-700 pl-10 pr-3 py-1 text-sm border border-gray-300 rounded-md"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//         </div>

//         {/* Desktop View */}
//         <div className="hidden md:flex items-center justify-between w-full">
//           <img src={logo} alt="Logo" className="h-14" />
//           <div className="space-x-6 text-md font-medium text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             {username !== "Guest" ? (
//               <div className="relative">
//                 <button
//                   onClick={() => setIsSignInOpen(!isSignInOpen)}
//                   className="hover:text-indigo-500 focus:outline-none"
//                 >
//                   <FaUserCircle className="inline mr-2" /> {username}
//                 </button>
//                 {isSignInOpen && (
//                   <div className="absolute top-full mt-2 w-36 bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                     <a
//                       href="/profile"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       Profile
//                     </a>
//                     <a
//                       href="/profile/myride"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       My Ride
//                     </a>
//                     <a
//                       href="/profile/wallet-amt"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       Wallet
//                     </a>
//                     <a
//                       href="/membership-card"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       Membership
//                     </a>
//                     <a
//                       href="/"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       onClick={handleSignOut}
//                     >
//                       <FaSignOutAlt className="mr-2" /> Logout
//                     </a>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <button
//                 onClick={() => navigate("/sign-in")}
//                 className="hover:text-indigo-500"
//               >
//                 Sign In
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {isMenuOpen && (
//         <div className="md:hidden bg-white absolute  top-16 left-0 w-3/4 h-[671px] z-10 shadow-lg ">
//           <div className="flex flex-col space-y-4 p-4 text-xl font-semibold text-gray-700">
//             {username !== "Guest" ? (
//               <a href="/" className="hover:text-indigo-500" onClick={handleSignOut}>
//                 Logout
//               </a>
//             ) : (
//               <a
//                 href='/login-signup'
//                 className="hover:text-indigo-500"
//                 onClick={() => navigate('/login-signup')}
//               >
//                 Login Or Signup
//               </a>
//             )}

//             <a href="/" className="hover:text-indigo-500 ">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500 border-t ">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500 border-t">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500 border-t">
//               Partner with us
//             </a>
//             <a href="/contact" className="hover:text-indigo-500 text-lg font-normal">
//               Contact us
//             </a>
//             <a href="/blog" className="hover:text-indigo-500 text-lg font-normal">
//              Blog
//             </a>
//             <a href="/about" className="hover:text-indigo-500 text-lg font-normal ">
//              FAQ
//             </a>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState, useRef, useEffect } from "react";
// import {
//   FaMapMarkerAlt,
//   FaBars,
//   FaTimes,
//   FaSignOutAlt,
//   FaLanguage,
//   FaUserCircle,
//   FaIdCardAlt,
//   FaWallet,
//   FaClipboardList,
// } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { logout } from "../../Redux/Slice/LoginSlice";   

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const menuRef = useRef(null); // Reference for the sidebar menu

//   // Get username from Redux store
//   const username = useSelector((state) => state.user.username);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//     };

//     if (isMenuOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isMenuOpen]);

//     return (
//       <div className="w-full h-auto mx-auto">
//         {/* First Row: Welcome Message & Dropdowns */}
//         <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//           <div className="text-sm font-medium text-white">
//             Hello! Welcome To Moveonwheels - Rent. Get. Go.
//           </div>
//           <div className="hidden md:flex items-center space-x-4">
//             <div className="relative border border-gray-400 rounded-lg">
//               <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//                 <FaMapMarkerAlt className="w-4 h-4 text-white" />
//               </div>
//               <div
//                 className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//                 onClick={handleLocationClick}
//               >
//                 {selectedLocation}
//               </div>
//             </div>
//             <div className="relative">
//               <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//                 <FaLanguage className="w-4 h-4 text-white" />
//               </div>
//               <select
//                 value={language}
//                 onChange={(e) => setLanguage(e.target.value)}
//                 className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//               >
//                 {["English", "Spanish", "French", "German"].map((lang, index) => (
//                   <option key={index} value={lang}>
//                     {lang}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* Second Row: Logo and Navigation Items */}
//         <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//           {/* Mobile View */}
//           <div className="flex items-center md:hidden w-full">
//             <button onClick={toggleMenu} className="mr-4">
//               {isMenuOpen ? (
//                 <FaTimes className="text-gray-700 w-6 h-6" />
//               ) : (
//                 <FaBars className="text-gray-700 w-6 h-6" />
//               )}
//             </button>
//             <img src={logo} alt="Logo" className="h-11 mr-6" />
//             <div className="relative flex-grow">
//               <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//                 <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
//               </div>
//               <div
//                 className="cursor-pointer text-gray-700 pl-10 pr-3 py-1 text-sm border border-gray-300 rounded-md"
//                 onClick={handleLocationClick}
//               >
//                 {selectedLocation}
//               </div>
//             </div>
//           </div>

//           {/* Desktop View */}
//           <div className="hidden md:flex items-center justify-between w-full">
//             <img src={logo} alt="Logo" className="h-14" />
//             <div className="space-x-2 text-md font-medium text-gray-700">
//               <a href="/" className="hover:text-indigo-500">
//                 Home
//               </a>
//               <a href="/product" className="hover:text-indigo-500">
//                 Our Fleet
//               </a>
//               <a href="/offers" className="hover:text-indigo-500">
//                 Offers
//               </a>
//               <a href="/franchise" className="hover:text-indigo-500">
//                 Partner with us
//               </a>
//               {username !== "Guest" ? (
//                 <div className="relative">
//                   <button
//                     onClick={() => setIsSignInOpen(!isSignInOpen)}
//                     className="hover:text-indigo-500 focus:outline-none"
//                   >
//                     <FaUserCircle className="inline mr-2" /> {username}
//                   </button>
//                   {isSignInOpen && (
//                     <div className="absolute top-full mt-2 w-36 bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                       <a
//                         href="/profile"
//                         className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       ><FaUserCircle className="mr-2" />
//                         Profile
//                       </a>
//                       <a
//                         href="/profile/myride"
//                         className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       >
//                         <FaClipboardList className="mr-2" />
//                         My Ride
//                       </a>
//                       <a
//                         href="/profile/wallet-amt"
//                         className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       >
//                         <FaWallet className="mr-2" />Wallet
//                       </a>
//                       <a
//                         href="/membership-card"
//                         className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       >
//                         < FaIdCardAlt className="mr-2" />
//                         Membership
//                       </a>
//                       <a
//                         href="/"
//                         className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                         onClick={handleSignOut}
//                       >
//                         <FaSignOutAlt className="mr-2" />Logout
//                       </a>
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <button
//                   onClick={() => navigate("/sign-in")}
//                   className="hover:text-indigo-500"
//                 >
//                   Sign In
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Mobile Menu */}
//         {isMenuOpen && (
//           <div 
//           ref={menuRef} // Attach ref to the sidebar container
//           className="md:hidden bg-white absolute top-16 left-0 w-3/4 h-[671px] z-10 shadow-lg">
//             <div className="flex flex-col space-y-4 p-4 text-xl font-semibold text-gray-700">
//               {username !== "Guest" ? (
//                 <>
//                   <div className="flex items-center space-x-2 text-lg font-medium">
//                     <FaUserCircle /> <span>{username}</span>
//                   </div>
//                   <a
//                     href="/"
//                     className="hover:text-indigo-500"
//                     onClick={handleSignOut}
//                   >
//                     Logout
//                   </a>
//                 </>
//               ) : (
//                 <a
//                   href="/login-signup"
//                   className="hover:text-indigo-500"
//                   onClick={() => navigate("/login-signup")}
//                 >
//                   Login or Signup
//                 </a>
//               )}
//               <a href="/" className="hover:text-indigo-500">
//                 Home
//               </a>
//               <a href="/product" className="hover:text-indigo-500 border-t">
//                 Our Fleet
//               </a>
//               <a href="/offers" className="hover:text-indigo-500 border-t">
//                 Offers
//               </a>
//               <a href="/franchise" className="hover:text-indigo-500 border-t">
//                 Partner with us
//               </a>
//               <a href="/contact" className="hover:text-indigo-500 text-lg font-normal">
//                 Contact Us
//               </a>
//               <a href="/blog" className="hover:text-indigo-500 text-lg font-normal">
//                 Blog
//               </a>
//               <a href="/about" className="hover:text-indigo-500 text-lg font-normal">
//                 FAQ
//               </a>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   export default Navbar;


// import React, { useState, useRef, useEffect } from "react";
// import {
//   FaMapMarkerAlt,
//   FaBars,
//   FaTimes,
//   FaSignOutAlt,
//   FaLanguage,
//   FaUserCircle,
//   FaIdCardAlt,
//   FaWallet,
//   FaClipboardList,
// } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { logout } from "../../Redux/Slice/LoginSlice";

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const menuRef = useRef(null); // Reference for the sidebar menu

//   // Get username from Redux store
//   const username = useSelector((state) => state.user.username);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//     };

//     if (isMenuOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isMenuOpen]);

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {["English", "Spanish", "French", "German"].map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         {/* Mobile View */}
//         <div className="flex items-center md:hidden w-full">
//           <button onClick={toggleMenu} className="mr-4">
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//           <img src={logo} alt="Logo" className="h-11 mr-6" />
//           <div className="relative flex-grow">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
//             </div>
//             <div
//               className="cursor-pointer text-gray-700 pl-10 pr-3 py-1 text-sm border border-gray-300 rounded-md"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//         </div>

//         {/* Desktop View */}
//         <div className="hidden md:flex items-center justify-between w-full">
//           <img src={logo} alt="Logo" className="h-14" />
//           <div className="space-x-2 text-md font-medium text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             {username !== "Guest" ? (
//               <div className="relative">
//                 <button
//                   onClick={() => setIsSignInOpen(!isSignInOpen)}
//                   className="hover:text-indigo-500 focus:outline-none"
//                 >
//                   <FaUserCircle className="inline mr-2" /> {username}
//                 </button>
//                 {isSignInOpen && (
//                   <div className="absolute top-full mt-2 w-36 bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                     <a
//                       href="/profile"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     ><FaUserCircle className="mr-2" />
//                       Profile
//                     </a>
//                     <a
//                       href="/profile/myride"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaClipboardList className="mr-2" />
//                       My Ride
//                     </a>
//                     <a
//                       href="/profile/wallet-amt"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaWallet className="mr-2" />Wallet
//                     </a>
//                     <a
//                       href="/membership-card"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       < FaIdCardAlt className="mr-2" />
//                       Membership
//                     </a>
//                     <a
//                       href="/"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       onClick={handleSignOut}
//                     >
//                       <FaSignOutAlt className="mr-2" />Logout
//                     </a>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <button
//                 onClick={() => navigate("/sign-in")}
//                 className="hover:text-indigo-500"
//               >
//                 Sign In
//               </button>
//             )}
//           </div>
//         </div>
//       </div>


//       {isMenuOpen && (
//         <div
//           ref={menuRef} // Attach ref to the sidebar container
//           className="md:hidden bg-white absolute top-16 left-0 w-3/4 h-[671px] z-10 shadow-lg">
//           <div className="flex flex-col space-y-4 p-4 text-xl font-semibold text-gray-700">
//             {username !== "Guest" ? (
//               <>
//                 <div className="flex items-center space-x-2 text-lg font-medium">
//                   <FaUserCircle /> <span>{username}</span>
//                 </div>
//                 <a
//                   href="/"
//                   className="hover:text-indigo-500"
//                   onClick={handleSignOut}
//                 >
//                   Logout
//                 </a>
//               </>
//             ) : (
//               <a
//                 href="/login-signup"
//                 className="hover:text-indigo-500"
//                 onClick={() => navigate("/login-signup")}
//               >
//                 Login or Signup
//               </a>
//             )}
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500 border-t">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500 border-t">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500 border-t">
//               Partner with us
//             </a>
//             <a href="/contact" className="hover:text-indigo-500 text-lg font-normal">
//               Contact Us
//             </a>
//             <a href="/blog" className="hover:text-indigo-500 text-lg font-normal">
//               Blog
//             </a>
//             <a href="/about" className="hover:text-indigo-500 text-lg font-normal">
//               FAQ
//             </a>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;

// Navbar.js


// import React, { useState, useRef, useEffect } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage, FaUserCircle, FaSignOutAlt ,FaIdCardAlt, FaWallet, FaClipboardList } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { logout } from "../../Redux/Slice/LoginSlice";
// import MobileSideBar from "../NavBar/MobileSidebar"; // Import the Sidebar component

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const menuRef = useRef(null);

//   // Get username from Redux store
//   const username = useSelector((state) => state.user.username);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//     };

//     if (isMenuOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isMenuOpen]);

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {["English", "Spanish", "French", "German"].map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         <div className="flex items-center md:hidden w-full">
//           <button onClick={toggleMenu} className="mr-4">
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//           <img src={logo} alt="Logo" className="h-11 mr-6" />
//           <div className="relative flex-grow">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
//             </div>
//             <div
//               className="cursor-pointer text-gray-700 pl-10 pr-3 py-1 text-sm border border-gray-300 rounded-md"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//         </div>

//         <div className="hidden md:flex items-center justify-between w-full">
//           <img src={logo} alt="Logo" className="h-14" />
//           <div className="space-x-2 text-md font-medium text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             {username !== "Guest" ? (
//               <div className="relative">
//                 <button
//                   onClick={() => setIsSignInOpen(!isSignInOpen)}
//                   className="hover:text-indigo-500 focus:outline-none"
//                 >
//                   <FaUserCircle className="inline mr-2" /> {username}
//                 </button>
//                 {isSignInOpen && (
//                   <div className="absolute top-full mt-2 w-36 bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                     <a
//                       href="/profile"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaUserCircle className="mr-2" />
//                       Profile
//                     </a>
//                     <a
//                       href="/profile/myride"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaClipboardList className="mr-2" />
//                       My Ride
//                     </a>
//                     <a
//                       href="/profile/wallet-amt"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaWallet className="mr-2" />Wallet
//                     </a>
//                     <a
//                       href="/membership-card"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaIdCardAlt className="mr-2" />
//                       Membership
//                     </a>
//                     <a
//                       href="/"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       onClick={handleSignOut}
//                     >
//                       <FaSignOutAlt className="mr-2" />Logout
//                     </a>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <button
//                 onClick={() => navigate("/sign-in")}
//                 className="hover:text-indigo-500"
//               >
//                 Sign In
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       <MobileSideBar
//         isMenuOpen={isMenuOpen}
//         menuRef={menuRef}
//         username={username}
//         handleSignOut={handleSignOut}
//       />
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState, useRef, useEffect } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage, FaUserCircle, FaSignOutAlt, FaIdCardAlt, FaWallet, FaClipboardList } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { logout } from "../../Redux/Slice/LoginSlice";
// import MobileSidebarLoggedIn from "../NavBar/MobileSidebarLoggedIn"; // Import the logged-in sidebar
// import MobileSidebarLoggedOut from "../NavBar/MobileSidebarLoggedOut"; // Import the logged-out sidebar

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const menuRef = useRef(null);

//   // Get username from Redux store
//   const username = useSelector((state) => state.user.username);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//     };

//     if (isMenuOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isMenuOpen]);

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {["English", "Spanish", "French", "German"].map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         <div className="flex items-center md:hidden w-full">
//           <button onClick={toggleMenu} className="mr-4">
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//           <img src={logo} alt="Logo" className="h-11 mr-6" />
//           <div className="relative flex-grow">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
//             </div>
//             <div
//               className="cursor-pointer text-gray-700 pl-10 pr-3 py-1 text-sm border border-gray-300 rounded-md"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//         </div>

//         <div className="hidden md:flex items-center justify-between w-full">
//           <img src={logo} alt="Logo" className="h-14" />
//           <div className="space-x-2 text-md font-medium text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             {username !== "Guest" ? (
//               <div className="relative">
//                 <button
//                   onClick={() => setIsSignInOpen(!isSignInOpen)}
//                   className="hover:text-indigo-500 focus:outline-none"
//                 >
//                   <FaUserCircle className="inline mr-2" /> {username}
//                 </button>
//                 {isSignInOpen && (
//                   <div className="absolute top-full mt-2 w-36 bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                     <a
//                       href="/profile"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaUserCircle className="mr-2" />
//                       Profile
//                     </a>
//                     <a
//                       href="/profile/myride"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaClipboardList className="mr-2" />
//                       My Ride
//                     </a>
//                     <a
//                       href="/profile/wallet-amt"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaWallet className="mr-2" />Wallet
//                     </a>
//                     <a
//                       href="/membership-card"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaIdCardAlt className="mr-2" />
//                       Membership
//                     </a>
//                     <a
//                       href="/"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       onClick={handleSignOut}
//                     >
//                       <FaSignOutAlt className="mr-2" />Logout
//                     </a>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <button
//                 onClick={() => navigate("/sign-in")}
//                 className="hover:text-indigo-500"
//               >
//                 Sign In
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Conditional Mobile Sidebar */}
//       {username !== "Guest" ? (
//         <MobileSidebarLoggedIn
//           isMenuOpen={isMenuOpen}
//           menuRef={menuRef}
//           username={username}
//           handleSignOut={handleSignOut}
//         />
//       ) : (
//         <MobileSidebarLoggedOut
//           isMenuOpen={isMenuOpen}
//           menuRef={menuRef}
//         />
//       )}
//     </div>
//   );
// };

// export default Navbar;


// import React, { useState, useRef, useEffect } from "react";
// import { FaMapMarkerAlt, FaBars, FaTimes, FaLanguage, FaUserCircle, FaSignOutAlt, FaIdCardAlt, FaWallet, FaClipboardList } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { logout } from "../../Redux/Slice/LoginSlice";
// import MobileSidebarLoggedIn from "../NavBar/MobileSidebarLoggedIn";
// import MobileSidebarLoggedOut from "../NavBar/MobileSidebarLoggedOut";

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const menuRef = useRef(null);

//   const username = useSelector((state) => state.user.username);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (menuRef.current && !menuRef.current.contains(event.target)) {
//         setIsMenuOpen(false);
//       }
//     };

//     if (isMenuOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isMenuOpen]);

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {["English", "Spanish", "French", "German"].map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         <div className="flex items-center md:hidden w-full">
//           <button onClick={toggleMenu} className="mr-4">
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//           <img src={logo} alt="Logo" className="h-11 mr-6" />
//           <div className="relative flex-grow">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
//             </div>
//             <div
//               className="cursor-pointer text-gray-700 pl-10 pr-3 py-1 text-sm border border-gray-300 rounded-md"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//         </div>

//         <div className="hidden md:flex items-center justify-between w-full">
//           <img src={logo} alt="Logo" className="h-14" />
//           <div className="space-x-2 text-md font-medium text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             {username !== "Guest" ? (
//               <button onClick={() => setIsSignInOpen(!isSignInOpen)} className="hover:text-indigo-500">
//                 <FaUserCircle className="inline mr-2" /> {username}
//               </button>
//             ) : (
//               <button onClick={() => navigate("/sign-in")} className="hover:text-indigo-500">
//                 Sign In
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Conditional Mobile Sidebar for Mobile View */}
//       {isMenuOpen && (
//         <div className="md:hidden">
//           {username !== "Guest" ? (
//             <MobileSidebarLoggedIn
//               isMenuOpen={isMenuOpen}
//               menuRef={menuRef}
//               username={username}
//               handleSignOut={handleSignOut}
//             />
//           ) : (
//             <MobileSidebarLoggedOut isMenuOpen={isMenuOpen} menuRef={menuRef} />
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;

// import React, { useState, useRef, useEffect } from "react";

// import {
//   FaMapMarkerAlt,
//   FaBars,
//   FaTimes,
//   FaLanguage,
//   FaUserCircle,
//   FaSignOutAlt,
//   FaIdCardAlt,
//   FaWallet,
//   FaClipboardList,
// } from "react-icons/fa";
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import logo from "../assets/logo2.png";
// import { logout } from "../../Redux/Slice/LoginSlice";
// import MobileSidebarLoggedIn from "../NavBar/MobileSidebarLoggedIn";
// import MobileSidebarLoggedOut from "../NavBar/MobileSidebarLoggedOut";

// const Navbar = () => {
//   const [selectedLocation, setSelectedLocation] = useState("Select Location");
//   const [language, setLanguage] = useState("English");
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isSignInOpen, setIsSignInOpen] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const menuRef = useRef(null);
//   const dropdownRef = useRef(null);

//   const username = useSelector((state) => state.user.username);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   const handleLocationClick = () => {
//     navigate("/location");
//   };

//   const handleSignOut = () => {
//     dispatch(logout());
//     navigate("/logout");
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsSignInOpen(false);
//       }
//     };

//     if (isSignInOpen) {
//       document.addEventListener("mousedown", handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [isSignInOpen]);

//   return (
//     <div className="w-full h-auto mx-auto">
//       {/* First Row: Welcome Message & Dropdowns */}
//       <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
//         <div className="text-sm font-medium text-white">
//           Hello! Welcome To Moveonwheels - Rent. Get. Go.
//         </div>
//         <div className="hidden md:flex items-center space-x-4">
//           <div className="relative border border-gray-400 rounded-lg">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-4 h-4 text-white" />
//             </div>
//             <div
//               className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//           <div className="relative">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaLanguage className="w-4 h-4 text-white" />
//             </div>
//             <select
//               value={language}
//               onChange={(e) => setLanguage(e.target.value)}
//               className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
//             >
//               {["English", "Spanish", "French", "German"].map((lang, index) => (
//                 <option key={index} value={lang}>
//                   {lang}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* Second Row: Logo and Navigation Items */}
//       <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
//         <div className="flex items-center md:hidden w-full">
//           <button onClick={toggleMenu} className="mr-4">
//             {isMenuOpen ? (
//               <FaTimes className="text-gray-700 w-6 h-6" />
//             ) : (
//               <FaBars className="text-gray-700 w-6 h-6" />
//             )}
//           </button>
//           <img src={logo} alt="Logo" className="h-11 mr-6" />
//           <div className="relative flex-grow">
//             <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
//               <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
//             </div>
//             <div
//               className="cursor-pointer text-gray-700 pl-10 pr-3 py-1 text-sm border border-gray-300 rounded-md"
//               onClick={handleLocationClick}
//             >
//               {selectedLocation}
//             </div>
//           </div>
//         </div>

//         <div className="hidden md:flex items-center justify-between w-full">
//           <img src={logo} alt="Logo" className="h-14" />
//           <div className="space-x-2 text-md font-medium text-gray-700">
//             <a href="/" className="hover:text-indigo-500">
//               Home
//             </a>
//             <a href="/product" className="hover:text-indigo-500">
//               Our Fleet
//             </a>
//             <a href="/offers" className="hover:text-indigo-500">
//               Offers
//             </a>
//             <a href="/franchise" className="hover:text-indigo-500">
//               Partner with us
//             </a>
//             {username !== "Guest" ? (
//               <div className="relative" ref={dropdownRef}>
//                 <button
//                   onClick={() => setIsSignInOpen(!isSignInOpen)}
//                   className="hover:text-indigo-500 flex items-center"
//                 >
//                   <FaUserCircle className="inline mr-2" /> {username}
//                 </button>
//                 {isSignInOpen && (
//                   <div className="absolute right-0 mt-2 w-36 bg-white shadow-md rounded-md py-2 z-50 border border-gray-200">
//                     <a
//                       href="/profile"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaUserCircle className="mr-2" />
//                       Profile
//                     </a>
//                     <a
//                       href="/profile/myride"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaClipboardList className="mr-2" />
//                       My Ride
//                     </a>
//                     <a
//                       href="/profile/wallet-amt"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaWallet className="mr-2" />
//                       Wallet
//                     </a>
//                     <a
//                       href="/membership-card"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                     >
//                       <FaIdCardAlt className="mr-2" />
//                       Membership
//                     </a>
//                     <a
//                       href="/"
//                       className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-indigo-100"
//                       onClick={handleSignOut}
//                     >
//                       <FaSignOutAlt className="mr-2" />
//                       Logout
//                     </a>
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <button onClick={() => navigate("/sign-in")} className="hover:text-indigo-500">
//                 Sign In
//               </button>
//             )}
//           </div>
//         </div>
//       </div>

//       {/* Conditional Mobile Sidebar for Mobile View */}
//       {isMenuOpen && (
//         <div className="md:hidden">
//           {username !== "Guest" ? (
//             <MobileSidebarLoggedIn
//               isMenuOpen={isMenuOpen}
//               menuRef={menuRef}
//               username={username}
//               handleSignOut={handleSignOut}
//             />
//           ) : (
//             <MobileSidebarLoggedOut isMenuOpen={isMenuOpen} menuRef={menuRef} />
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Navbar;

import React, { useState, useRef, useEffect } from "react";

import {
  FaMapMarkerAlt,
  FaBars,
  FaTimes,
  FaLanguage,
  FaUserCircle,
  FaSignOutAlt,
  FaIdCardAlt,
  FaWallet,
  FaClipboardList,
  FaChevronDown
} from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo2.png";
import { logout } from "../../Redux/Slice/LoginSlice";
import MobileSidebarLoggedIn from "../NavBar/MobileSidebarLoggedIn";
import MobileSidebarLoggedOut from "../NavBar/MobileSidebarLoggedOut";

const Navbar = () => {
  // const [selectedLocation, setSelectedLocation] = useState("Select Location");
  const [language, setLanguage] = useState("English");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSignInOpen, setIsSignInOpen] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const menuRef = useRef(null);
  const dropdownRef = useRef(null);

  const username = useSelector((state) => state.user.username);
  const selectedLocation = useSelector((state) => state.location.selectedLocation);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLocationClick = () => {
    navigate("/location");
  };

  const handleSignOut = () => {
    dispatch(logout());
    navigate("/logout");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsSignInOpen(false);
      }
    };

    if (isSignInOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSignInOpen]);

  return (
    <div className="w-full h-auto mx-auto">
      {/* First Row: Welcome Message & Dropdowns */}
      <div className="w-full h-14 border-b border-gray-300 flex items-center justify-between px-4 md:px-20 bg-[#FF9630]">
        <div className="text-sm font-medium text-white">
          Hello! Welcome To Moveonwheels - Rent. Get. Go.
        </div>
        <div className="hidden md:flex items-center space-x-4">

          <div className="hidden md:flex items-center space-x-4">
            <div className="relative border border-gray-400 rounded-lg">
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                <FaMapMarkerAlt className="w-4 h-4 text-white" />
              </div>
              <div
                className="cursor-pointer text-white pl-10 pr-3 py-1 text-sm"
                onClick={handleLocationClick}
              >
                {selectedLocation}
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <FaLanguage className="w-4 h-4 text-white" />
            </div>
            <select
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
              className="border border-gray-400 text-white rounded-md pl-10 pr-3 py-1 text-sm focus:outline-none bg-[#FF9630]"
            >
              {["English", "Spanish", "French", "German"].map((lang, index) => (
                <option key={index} value={lang}>
                  {lang}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Second Row: Logo and Navigation Items */}
      <div className="h-20 flex items-center justify-between shadow-md px-4 md:px-28">
        <div className="flex items-center md:hidden w-full">
          <button onClick={toggleMenu} className="mr-4">
            {isMenuOpen ? (
              <FaTimes className="text-gray-700 w-6 h-6" />
            ) : (
              <FaBars className="text-gray-700 w-6 h-6" />
            )}
          </button>
          <img src={logo} alt="Logo" className="h-11 mr-10" />
          <div className="relative flex-grow">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
              <FaMapMarkerAlt className="w-6 h-4 text-gray-700" />
            </div>
            <div
              className="cursor-pointer text-gray-700 pl-10 w-40 pr-3 py-1 text-sm border border-gray-300 rounded-md"
              onClick={handleLocationClick}
            >
              {selectedLocation}
            </div>
          </div>
        </div>

        <div className="hidden md:flex items-center justify-between w-full">
          <img src={logo} alt="Logo" className="h-14" />
          <div className="space-x-4 text-md font-medium text-gray-700 flex items-center">
            <a href="/" className="hover:text-indigo-500">
              Home
            </a>
            <a href="/product" className="hover:text-indigo-500">
              Our Fleet
            </a>
            <a href="/offers" className="hover:text-indigo-500">
              Offers
            </a>
            <a href="/franchise" className="hover:text-indigo-500">
              Partner with us
            </a>
            {username !== "Guest" ? (
              <div className="relative" ref={dropdownRef}>
                {/* Dropdown Trigger */}
                <button
                  onClick={() => setIsSignInOpen(!isSignInOpen)}
                  className="flex items-center text-white bg-[#FF9630] px-4 py-2 rounded-md hover:bg-orange-600"
                  style={{ width: "180px", height: "40px" }}
                >
                  <FaUserCircle className="mr-3" />
                  {username}
                  <FaChevronDown className="ml-10" />
                </button>

                {/* Dropdown Menu */}
                {isSignInOpen && (
                  <div
                    className="absolute right-0  bg-white shadow-md rounded-md z-50 border border-gray-200"
                    style={{ width: "180px" }} // Fixed width for dropdown
                    ref={dropdownRef}
                  >
                    <a
                      href="/profile"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      style={{ height: "50px" }} // Fixed height for each item
                    >
                      <FaUserCircle className="mr-3" />
                      My Profile
                    </a>
                    <a
                      href="/profile/myride"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      style={{ height: "50px" }}
                    >
                      <FaClipboardList className="mr-3" />
                      My Ride
                    </a>
                    <a
                      href="/profile/wallet-amt"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      style={{ height: "50px" }}
                    >
                      <FaWallet className="mr-3" />
                      Wallet
                    </a>
                    <a
                      href="/membership-card"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      style={{ height: "50px" }}
                    >
                      <FaIdCardAlt className="mr-3" />
                      Membership
                    </a>
                    <a
                      href="/"
                      className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                      onClick={handleSignOut}
                      style={{ height: "50px" }}
                    >
                      <FaSignOutAlt className="mr-3" />
                      Logout
                    </a>
                  </div>
                )}
              </div>
            ) : (
              <button
                onClick={() => navigate("/sign-in")}
                className="hover:text-indigo-500"
              >
                Sign In
              </button>
            )}
          </div>
        </div>

      </div>

     
      {isMenuOpen && (
        <div className="md:hidden">
          {username !== "Guest" ? (
            <MobileSidebarLoggedIn
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen} // Pass it here
              menuRef={menuRef}
              handleSignOut={handleSignOut}
            />
          ) : (
            <MobileSidebarLoggedOut
              isMenuOpen={isMenuOpen}
              setIsMenuOpen={setIsMenuOpen} // Pass it here
              menuRef={menuRef}
            />
          )}
        </div>
      )}

    </div>
  );
};

export default Navbar;
